import { Injectable } from '@angular/core';
import {
	CachePolicy,
	CachePolicyEntity,
	UrlService,
} from '@datachain/ui-sdk/common';
import { catchError, firstValueFrom, map, of } from 'rxjs';

import { DcCoreElementType } from '../../core/dc-core-types';
import { DcBaseRequester } from '../core/dc-base.requester';

@Injectable({
	providedIn: 'root',
})
export class AjsElementCheckerRequester extends DcBaseRequester<unknown> {
	protected resource: string;
	protected elementsListUrl: string;
	protected singleElementUrl: string;

	public constructor(private readonly urlService: UrlService) {
		super();
		this.resource = '';
		this.elementsListUrl = this.resource;
		this.singleElementUrl = this.resource;
	}

	public async elementExists(
		elType: DcCoreElementType,
		elId: number
	): Promise<boolean> {
		const apiKey = this.getApiKeyForElement(elType);

		if (!apiKey) {
			return false;
		}

		const url = this.urlService.generateUrl(
			this.generateResourceUrl(apiKey),
			{
				id: elId,
			},
			{
				project: this.projectId,
			}
		);

		return await firstValueFrom(
			this.http.head(url).pipe(
				map((el) => true),
				catchError(() => of(false))
			)
		);
	}

	private getApiKeyForElement(type: DcCoreElementType): string | null {
		switch (type) {
			case DcCoreElementType.DATALINK:
				return 'DATALINKS_BY_ID';
			default:
				return null;
		}
	}
}
